import React from 'react'
import { Box, Tabs, Tab } from '@mui/material'
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart'
import LocationOnIcon from '@mui/icons-material/LocationOn'
import PaymentIcon from '@mui/icons-material/Payment'
import { useTranslation } from 'react-i18next'

type TabsComponentProps = {
  selectedTab: number
  onClick: (index: number) => void
}

const TabsComponent: React.FC<TabsComponentProps> = ({
  selectedTab,
  onClick
}) => {
  const { t } = useTranslation()
  const tabLabels = [
    { label: t('myAccount.tabs.myOrders'), icon: <ShoppingCartIcon /> },
    { label: t('myAccount.tabs.addressBook'), icon: <LocationOnIcon /> },
    { label: t('myAccount.tabs.paymentMethods'), icon: <PaymentIcon /> }
  ]

  return (
    <Box
      sx={{
        width: '100%',
        mt: 3,
        mb: 4,
        px: 2
      }}
    >
      <Box
        sx={{
          bgcolor: 'white',
          borderRadius: 3,
          boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
          p: 1.5,
          maxWidth: '1000px',
          mx: 'auto',
          border: '1px solid',
          borderColor: 'divider'
        }}
      >
        <Tabs
          value={selectedTab}
          onChange={(event, newValue) => onClick(newValue)}
          variant='fullWidth'
          sx={{
            '& .MuiTabs-flexContainer': {
              gap: 1
            },
            '& .MuiTab-root': {
              py: 2,
              px: 2.5,
              minHeight: '64px',
              textTransform: 'none',
              fontFamily: 'Inter',
              fontSize: '0.9rem',
              fontWeight: 500,
              borderRadius: 2,
              color: 'text.secondary',
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              '&:hover': {
                bgcolor: 'rgba(25, 118, 210, 0.08)',
                color: 'primary.main',
                transform: 'translateY(-2px)'
              }
            },
            '& .Mui-selected': {
              fontWeight: 700,
              color: 'white !important',
              bgcolor: 'primary.main',
              boxShadow: '0 4px 12px rgba(25, 118, 210, 0.4)',
              '&:hover': {
                bgcolor: 'primary.main',
                transform: 'translateY(-2px)',
                boxShadow: '0 6px 16px rgba(25, 118, 210, 0.5)'
              }
            },
            '& .MuiTab-iconWrapper': {
              mb: 0.5,
              fontSize: '1.3rem'
            }
          }}
          TabIndicatorProps={{
            style: {
              display: 'none'
            }
          }}
        >
          {tabLabels.map((tab, index) => (
            <Tab
              key={index}
              label={tab.label}
              icon={tab.icon}
              iconPosition='top'
            />
          ))}
        </Tabs>
      </Box>
    </Box>
  )
}

export default TabsComponent
